import { useCallback, useEffect } from 'react'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Page } from '@/components/layout/page/page.tsx'
import { Button } from '@/components/ui/button'
import { SearchInput } from '@/components/ui/search-input'
import { DIALOG_TYPE } from '@/dialogs/constants'
import { openDialog } from '@/models/dialogs.ts'
import { useProspects } from '@/modules/prospects/hooks/use-prospects'
import { ProspectsPlaceholder } from '@/modules/prospects/ui/prospects-placeholder/ProspectsPlaceholder'
import { ProspectsTable } from '@/modules/prospects/ui/prospects-table/ProspectsTable'
import { TrackedFeatures, trackFeatureUsage } from '@/utils/feature-engagement'
import { debounce } from '@/utils/helpers'
import { usePagination } from '@/utils/pagination/pagination-context'

export const ProspectsView = () => {
  const { searchQuery, setSearchQuery } = usePagination()
  const { prospects, isLoading, pageCount } = useProspects()

  const handleAdd = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.ADD_PROSPECT,
    })
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSearch = useCallback(debounce(setSearchQuery, 500), [
    setSearchQuery,
  ])

  useEffect(() => {
    if (prospects.length) {
      trackFeatureUsage(TrackedFeatures.Prospects)
    }
  }, [prospects.length])

  if (!isLoading && !prospects.length && !searchQuery) {
    return <ProspectsPlaceholder onAdd={handleAdd} />
  }

  return (
    <Page
      title="Prospects"
      headerOptions={
        <div className="flex items-center gap-4">
          <SearchInput
            placeholder="Search"
            onInputChange={handleSearch}
            testId="search-input"
          />
          <Button
            onClick={handleAdd}
            testId="add-prospect"
          >
            <PlusIcon />
            Add Prospect
          </Button>
        </div>
      }
    >
      <ProspectsTable
        data={prospects}
        isLoading={isLoading}
        pageCount={pageCount}
      />
    </Page>
  )
}
